declare const window

const segmentIdentify = (
  str,
  obj = {},
  options = {},
  callback = () => undefined
) => {
  try {
    window.analytics.identify(str, obj, options, callback)
  } catch (err) {
    if (callback) {
      callback()
    }
  }
}

export default segmentIdentify
